var path = 'app/scripts/modules/kubernetes/src/v2/pipelines/stages/deleteManifest/deleteManifestConfig.html';
var html = "<div class=\"form-horizontal\">\n  <div class=\"alert alert-warning\">\n    <strong>Warning!</strong> This stage is under active development and is subject to change.\n  </div>\n  <h4>Manifest</h4>\n  <div class=\"horizontal-rule\"></div>\n  <kubernetes-multi-manifest-selector selector=\"ctrl.$scope.stage\"></kubernetes-multi-manifest-selector>\n  <h4>Settings</h4>\n  <div class=\"horizontal-rule\"></div>\n  <kubernetes-delete-manifest-options-form options=\"ctrl.$scope.stage.options\"></kubernetes-delete-manifest-options-form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/v2/pipelines/stages/deleteManifest/deleteManifestConfig.html
// module id = 1531
// module chunks = 0